
























/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint vue/no-v-html: 0 */
import Vue from 'vue'
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'

import { RootState } from '@/store'

export default Vue.extend({
  name: 'AgreementContract',
  mixins: [validationMixin],
  validations: {
    confirm: {
      checked: value => value === true
    }
  },
  computed: {
    ...mapState({
      report: state => (state as RootState).agreement!.report.contract
    }),
    confirm: { // setterが必要
      get: function () { return (this.$store.state as RootState).agreement!.confirm.contract },
      set: () => { /* do nothing */ }
    },
    confirmError (): string {
      const confirm = this.$v.confirm!
      if (!confirm.$dirty) {
        return ''
      }
      return !confirm.checked ? '問題なければチェックをつけて下さい' : ''
    }
  },
  created (): void {
    this.$store.dispatch('agreement/getContract')
  },
  mounted (): void {
    // レポート取得済みの場合、スクロール制御しない
    if (this.report.contents || !window.MutationObserver) {
      return
    }
    const target = document.querySelector('.document-body')!
    const observer = new MutationObserver((mutation) => {
      if (mutation[0].addedNodes.length) {
        window.scrollTo(0, 0)
        observer.disconnect()
      }
    })
    observer.observe(target, { characterData: true, attributes: false, childList: false })
  },
  beforeRouteLeave (to, from, next) {
    // 規約等の同意画面から離れる時は、moduleの値をクリアする
    if ((to.name as string).indexOf('agreement') !== 0) {
      this.$store.commit('agreement/resetConfirm')
    }
    next()
  },
  methods: {
    /**
     * 電子交付サービス約款、取引約款等を閲覧し、書面の電子交付に同意します
     */
    checkConfirm (value: boolean): void {
      this.$store.commit('agreement/confirm', { key: 'contract', value })
    },
    submit (): void {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.$router.push({ name: 'agreementPreContract' })
    }
  }
})
